import {
  Box,
  Card,
  CardContent,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import isMobile from "./isMobile";

const Loader = () => {
  const theme = useTheme();
  const mobileView = isMobile();
  const skeletonCards = Array(mobileView ? 6 : 12).fill(0);

  return (
    <Grid container spacing={0.5}>
      {skeletonCards.map((_, index) => (
        <Grid item xs={6} sm={4} md={3} key={index} style={{ display: "flex" }}>
          <Card
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              padding: "10px",
              border: "1px solid #d3d3d3", // Gray border
              borderRadius: "8px",
              boxShadow: "none",
              height: "350px", // Dynamic height
              transition: "height 0.3s ease", // Smooth transition
            }}
          >
            <Skeleton width={mobileView ? 155 : 267} height={140} />
            <CardContent
              style={{
                padding: "0",
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Container to manage content spacing */}
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  marginBottom: "3px"
                }}
              >
                <Skeleton width={mobileView ? 155 : 250} count={3} height={16} />
                {/* Spacer to push content to the bottom */}
                <Box sx={{ flexGrow: 1, marginBottom: "10px" }} />
                <Skeleton width={48.17} height={20.59} />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "5px",
                    flexShrink: 0,
                  }}
                >
                  <Skeleton width={20} style={{ marginRight: "3px" }} height={18} />
                  <Skeleton width={48.17} height={18.3} />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    flexShrink: 0,
                  }}
                >
                  <Skeleton width={mobileView ? 64 : 87.63} height={mobileView ? 27.59 : 35.59} />
                  <Skeleton width={mobileView ? 64 : 87.63} height={mobileView ? 27.59 : 35.59} />
                </div>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default Loader;
